export enum SpeedResultState {
  FAST,
  SLOW,
  UNSTABLE,
}
